import { render } from "./recycle.vue?vue&type=template&id=52be3dda&ts=true"
import script from "./recycle.vue?vue&type=script&lang=ts"
export * from "./recycle.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/zhongyue/Desktop/work/hu-shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__